<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <el-date-picker v-model="timevalue" size="small" type="datetimerange"
                      :picker-options="pickerOptions2" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期"
                      align="right" value-format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
      <div>
        <input-select selectTitle="事件" :selectKey="'event'" :selectData="eventList" @search="searchCardType"/>
      </div>
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="操作人/操作内容" @search="search"/>
        <button-export
          style="margin-left: 5px"
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          value="导出"/>
      </div>
    </div>
    <table-main :selection="selection" :hasOperation="hasOperation" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import InputDatePicker from "../components/Input/InputDatePicker";
import InputSearch from "../components/Input/InputSearch";
import TableMain from "../components/Table/TableMain";
import ButtonExport from "../components/common/buttons/button-export";
import { api } from "./api/common";
import { errorHandler } from "../utils/errorHandler";
import InputSelect from "../components/Input/InputSelect";
import { bus } from "../utils/bus";

export default {
  components: {
    InputSelect,
    ButtonExport,
    TableMain,
    InputSearch,
    InputDatePicker,
    Breadcrumb
  },
  name: "log",
  data() {
    return {
      breadcrumb: [
        {
          value: "资源中心",
          name: "business-management"
        },
        {
          value: "操作日志"
        }
      ],
      selectTitle: "租赁状态",
      selection: false,
      hasOperation: false,
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      exportUrl: "",
      timevalue: [],
      eventList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: "新增",
          label: "新增"
        },
        {
          key: "删除",
          label: "删除"
        },
        {
          key: "修改",
          label: "修改"
        },
        {
          key: "导入",
          label: "导入"
        }
      ],
      tableHead: [
        {
          prop: "opratorName",
          label: "操作人"
        },
        {
          prop: "event",
          label: "操作事件"
        },
        {
          prop: "description",
          label: "操作内容"
        },
        {
          prop: "oprateTime",
          label: "操作时间"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      requestUrl: "",
      requestData: {
        searchKey: "",
        startTime: "",
        endTime: "",
        moduleCode: "",
        event: ""
      }
    };
  },
  created() {
    let routeName = this.$route.name;
    if (routeName === "resource-center-log") {
      this.requestData.moduleCode = "1";
      this.requestUrl = `${api.getLogPage}/1`;
      this.breadcrumb = [
        {
          value: "资源中心",
          name: "business-management"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "investment-leasing-log") {
      this.requestData.moduleCode = "2";
      this.requestUrl = `${api.getLogPage}/2`;
      this.breadcrumb = [
        {
          value: "智慧合约",
          name: "custom-management"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "access-ctrl-log") {
      this.requestData.moduleCode = "3";
      this.requestUrl = `${api.getLogPage}/3`;
      this.breadcrumb = [
        {
          value: "智慧门禁",
          name: "accessCtrlDeviceManagementCenter"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "yqing-service-log") {
      this.requestData.moduleCode = "4";
      this.requestUrl = `${api.getLogPage}/4`;
      this.breadcrumb = [
        {
          value: "智慧停车",
          name: "amount-allocation"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "electronic-control-log") {
      this.requestData.moduleCode = "5";
      this.requestUrl = `${api.getLogPage}/5`;
      this.breadcrumb = [
        {
          value: "智慧用电",
          name: "electronic-config"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "pay-service-log") {
      this.requestData.moduleCode = "6";
      this.requestUrl = `${api.getLogPage}/6`;
      this.breadcrumb = [
        {
          value: "缴费服务",
          name: "housing-management"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "visitor-service-log") {
      this.requestData.moduleCode = "7";
      this.requestUrl = `${api.getLogPage}/7`;
      this.breadcrumb = [
        {
          value: "智慧访客",
          name: "appointment-record"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "site-reservation-log") {
      this.requestData.moduleCode = "8";
      this.requestUrl = `${api.getLogPage}/8`;
      this.breadcrumb = [
        {
          value: "智慧预约",
          name: "pay-record"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "config-center-log") {
      this.requestData.moduleCode = "9";
      this.requestUrl = `${api.getLogPage}/9`;
      this.breadcrumb = [
        {
          value: "配置中心",
          name: "config-basic"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "ladder-control-log") {
      this.requestData.moduleCode = "10";
      this.requestUrl = `${api.getLogPage}/10`;
      this.breadcrumb = [
        {
          value: "智慧梯控",
          name: "ladder-device"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "value-added-log") {
      this.requestData.moduleCode = "11";
      this.requestUrl = `${api.getLogPage}/11`;
      this.breadcrumb = [
        {
          value: "严选服务",
          name: "service-category-manage"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "activity-log") {
      this.requestData.moduleCode = "12";
      this.requestUrl = `${api.getLogPage}/12`;
      this.breadcrumb = [
        {
          value: "智慧活动",
          name: "activity-manage"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "fire-control-log") {
      this.requestData.moduleCode = "13";
      this.requestUrl = `${api.getLogPage}/13`;
      this.breadcrumb = [
        {
          value: "智慧消防",
          name: "gateway-device"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "video-services-log") {
      this.requestData.moduleCode = "14";
      this.requestUrl = `${api.getLogPage}/14`;
      this.breadcrumb = [
        {
          value: "智慧监控",
          name: "video-device"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "alarm-manage-log") {
      this.requestData.moduleCode = "15";
      this.requestUrl = `${api.getLogPage}/15`;
      this.breadcrumb = [
        {
          value: "报警中心",
          name: "alarm-device-add"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "message-log") {
      this.requestData.moduleCode = "16";
      this.requestUrl = `${api.getLogPage}/16`;
      this.breadcrumb = [
        {
          value: "智慧消息",
          name: "message-over-view"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "air-conditioner-log") {
      this.requestData.moduleCode = "17";
      this.requestUrl = `${api.getLogPage}/17`;
      this.breadcrumb = [
        {
          value: "智慧空调",
          name: "air-conditioning-gateway-device"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "inspection-log") {
      this.requestData.moduleCode = "18";
      this.requestUrl = `${api.getLogPage}/18`;
      this.breadcrumb = [
        {
          value: "智慧巡检",
          name: "inspection-device-type-manage"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "water-control-log") {
      this.requestData.moduleCode = "19";
      this.requestUrl = `${api.getLogPage}/19`;
      this.breadcrumb = [
        {
          value: "智慧用水",
          name: "water-over-view"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "keep-watch-log") {
      this.requestData.moduleCode = "20";
      this.requestUrl = `${api.getLogPage}/20`;
      this.breadcrumb = [
        {
          value: "智慧巡更",
          name: "patrol-point-manage"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "repair-manage-log") {
      this.requestData.moduleCode = "21";
      this.requestUrl = `${api.getLogPage}/21`;
      this.breadcrumb = [
        {
          value: "智慧报修",
          name: "repair-over-view"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "data-service-log") {
      this.requestData.moduleCode = "22";
      this.requestUrl = `${api.getLogPage}/22`;
      this.breadcrumb = [
        {
          value: "园区数据",
          name: "data-park-basic"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "data-enterprise-log") {
      this.requestData.moduleCode = "23";
      this.requestUrl = `${api.getLogPage}/23`;
      this.breadcrumb = [
        {
          value: "企业数据",
          name: "data-enterprise"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "incubation-log") {
      this.requestData.moduleCode = "24";
      this.requestUrl = `${api.getLogPage}/24`;
      this.breadcrumb = [
        {
          value: "智慧孵化",
          name: "incubation-application"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "smart-detection-log") {
      this.requestData.moduleCode = "25";
      this.requestUrl = `${api.getLogPage}/25`;
      this.breadcrumb = [
        {
          value: "智慧检测",
          name: "smart-detection-over-view"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "work-attendance-log") {
      this.requestData.moduleCode = "26";
      this.requestUrl = `${api.getLogPage}/26`;
      this.breadcrumb = [
        {
          value: "智慧考勤",
          name: "work-attendance-over-view"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "invoice-log") {
      this.requestData.moduleCode = "27";
      this.requestUrl = `${api.getLogPage}/27`;
      this.breadcrumb = [
        {
          value: "智慧凭证",
          name: "invoice-over-view"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "questionnaire-log") {
      this.requestData.moduleCode = "28";
      this.requestUrl = `${api.getLogPage}/28`;
      this.breadcrumb = [
        {
          value: "数据采集",
          name: "questionnaire-template-manage"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "material-log") {
      this.requestData.moduleCode = "29";
      this.requestUrl = `${api.getLogPage}/29`;
      this.breadcrumb = [
        {
          value: "物资管理",
          name: "material-category-manage"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "charge-log") {
      this.requestData.moduleCode = "30";
      this.requestUrl = `${api.getLogPage}/30`;
      this.breadcrumb = [
        {
          value: "智慧收费",
          name: "charge_items_management"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "finance-log") {
      this.requestData.moduleCode = "31";
      this.requestUrl = `${api.getLogPage}/31`;
      this.breadcrumb = [
        {
          value: "智慧财务",
          name: "finance-over-view"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "agent-log") {
      this.requestData.moduleCode = "32";
      this.requestUrl = `${api.getLogPage}/32`;
      this.breadcrumb = [
        {
          value: "智慧招商",
          name: "investment-manage"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "document-log") {
      this.requestData.moduleCode = "33";
      this.requestUrl = `${api.getLogPage}/33`;
      this.breadcrumb = [
        {
          value: "智慧文书",
          name: "contract-template"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "customer-log") {
      this.requestData.moduleCode = "35";
      this.requestUrl = `${api.getLogPage}/35`;
      this.breadcrumb = [
        {
          value: "客流应用",
          name: "customer-flow-over-view"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "face-log") {
      this.requestData.moduleCode = "36";
      this.requestUrl = `${api.getLogPage}/36`;
      this.breadcrumb = [
        {
          value: "人脸应用",
          name: "monitoring-point-management"
        },
        {
          value: "操作日志"
        }
      ];
    }else if (routeName === "gas-log") {
      this.requestData.moduleCode = "38";
      this.requestUrl = `${api.getLogPage}/38`;
      this.breadcrumb = [
        {
          value: "智慧燃气",
          name: "gas-over-view"
        },
        {
          value: "操作日志"
        }
      ];
    }else if (routeName === "steam-log") {
      this.requestData.moduleCode = "37";
      this.requestUrl = `${api.getLogPage}/37`;
      this.breadcrumb = [
        {
          value: "智慧蒸汽",
          name: "steam-over-view"
        },
        {
          value: "操作日志"
        }
      ];
    }else if (routeName === "lock-log") {
      this.requestData.moduleCode = "43";
      this.requestUrl = `${api.getLogPage}/43`;
      this.breadcrumb = [
        {
          value: "智慧门锁",
          name: "lock-concentrator-manage"
        },
        {
          value: "操作日志"
        }
      ];
    } else if (routeName === "hotel-check-in-log") {
      this.requestData.moduleCode = "43";
      this.requestUrl = `${api.getLogPage}/43`;
      this.breadcrumb = [
        {
          value: "酒店入住",
          name: "lock-concentrator-manage"
        },
        {
          value: "操作日志"
        }
      ];
    }
    this.getCreatTime();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportLog}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&startTime=${this.requestData.startTime}&endTime=${
        this.requestData.endTime
      }&moduleCode=${this.requestData.moduleCode}&event=${
        this.requestData.event
      }`;
    },
    getCreatTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-01" + " " + "00:00:00";
      this.timevalue[1] =
        year +
        "-" +
        month +
        "-" +
        date +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    searchCardType(v) {
      this.requestData.event = v.value;
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || "";
        this.requestData.endTime = this.timevalue[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      this.$axios
        .post(this.requestUrl, reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            this.total = res.data.data.total;
            // data.map((v, i) => {
            //   if (v.parentCode === '0') {
            //     data.splice(i, 1)
            //   }
            // })
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取操作记录失败"));
    }
  },
  watch: {
    timevalue(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.main-btn {
  color: #ffffff;
  background-color: #00a0e6;
  border: none;
}
.main-btn:hover {
  color: #ffffff;
  background-color: #06b3ff;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/view/log.vue